var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "collapse_icon",
    "data-name": "collapse icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.46,
    viewBox: "0 0 18 13.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 11.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M99.375,403.7H85.352a.752.752,0,0,1,0-1.5H99.375a.752.752,0,0,1,0,1.5Z",
    transform: "translate(-84.6 -402.2)",
    fill: "#adb4d2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0.004 5.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M17.269,239.1H.728a.752.752,0,0,1,0-1.5H17.269a.752.752,0,0,1,0,1.5Z",
    transform: "translate(0 -237.6)",
    fill: "#adb4d2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M186.106,74.5H175.352a.752.752,0,1,1,0-1.5h10.75a.752.752,0,1,1,0,1.5Z",
    transform: "translate(-174.6 -73)",
    fill: "#adb4d2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand_icon.8ec180e52dee56afd0018af919df10bd.svg";
export { ForwardRef as ReactComponent };